import React from "react";
import useBreakpoints from "@/modules/hooks/use-breakpoints";
import polyglot from "@/utils/polyglot";
import { artwork } from "../../assets/categories";
import { spacings } from "../../assets/themes";
import { getCategoryFormUrlById } from "../../utils/index";
import List from "@/components/list";
import Shape from "@/components/shape";
import { SHAPE } from "@/components/styles/variants/shape";

const MemoizedList = React.memo(
  ({ children, ...props }) => <List.Item {...props}>{children}</List.Item>,
  () => true
);

const SearchItem = ({ elem, url_params, onClick }) => {
  const breakpoints = useBreakpoints();
  return (
    <MemoizedList
      chevron
      css={breakpoints.get({
        xs: undefined,
        sm: `
          &:hover {
            img {
              transform: scale(1.1);
            }
          }
        `,
      })}
      href={elem.id >= 1000 ? getCategoryFormUrlById(elem.id, url_params) : undefined}
      key={`${elem.id}-search-item`}
      LeftComponent={() => (
        <Shape.Small
          backgroundColor="transparent"
          css={`
            overflow: hidden;
            margin: ${spacings.xs} 0;
          `}
          shape={SHAPE.SHAPE.ROUND}
          size={breakpoints.get({
            xs: SHAPE.SIZE.MEDIUM,
            md: SHAPE.SIZE.LARGE,
          })}
        >
          <img
            alt={polyglot.t(`categories.${elem.id}.name`)}
            css={`
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: right bottom;
              transform: scale(1);
              transition: 0.1s ease-in-out;
            `}
            src={artwork[elem.id]}
          />
        </Shape.Small>
      )}
      onClick={elem.id < 1000 ? onClick : undefined}
      withGutters
    >
      <List.Elem.Title
        className={breakpoints.get({
          xs: "",
          sm: "font-size-sm-4",
        })}
      >
        {polyglot.t(`categories.${elem.id}.name`)?.split(":").pop()}
      </List.Elem.Title>
    </MemoizedList>
  );
};

export default SearchItem;
